module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_pp2_8011.a4c85f54.png";